import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { NAV, TRUST } from "../../lib/data";
import client from "../../lib/api";
import Logo from "./Logo";

const SLUG_PATH = {
  privacy: "/privacy",
  terms: "/terms",
  disclaimer: "/disclaimer",
  cookie: "/cookie-policy",
  donation: "/donation-policy",
};

export default function Footer() {
  const [legal, setLegal] = useState([]);
  useEffect(() => {
    client.get("/public/legal").then(({ data }) => setLegal(data)).catch(() => {});
  }, []);
  return (
    <footer className="border-t border-gold/20 bg-maroon text-ivory">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 lg:grid-cols-[1.6fr_1fr_1fr_1fr] lg:px-10">
        <div className="lg:col-span-1">
          <Logo variant="footer" />
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-gold-light">Registered Address</h4>
          <address className="mt-4 not-italic text-sm leading-relaxed text-ivory/80">
            {TRUST.addressLines.map((l) => <div key={l}>{l}</div>)}
          </address>
          <a href={`mailto:${TRUST.email}`} className="mt-4 inline-flex items-center gap-2 text-sm text-ivory/90 hover:text-gold-light" data-testid="footer-email">
            <Mail size={15} /> {TRUST.email}
          </a>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-gold-light">Quick Links</h4>
          <ul className="mt-4 space-y-2 text-sm">
            {NAV.map((n) => (
              <li key={n.to}><Link to={n.to} className="text-ivory/80 hover:text-gold-light">{n.label}</Link></li>
            ))}
            <li><Link to="/support" className="text-ivory/80 hover:text-gold-light">Support Our Mission</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-gold-light">Legal</h4>
          <ul className="mt-4 space-y-2 text-sm" data-testid="footer-legal">
            {legal.filter((l) => SLUG_PATH[l.slug]).map((l) => (
              <li key={l.slug}><Link to={SLUG_PATH[l.slug]} className="text-ivory/80 hover:text-gold-light">{l.title}</Link></li>
            ))}
          </ul>
          <div className="mt-6 text-xs leading-relaxed text-ivory/60">
            Est. {TRUST.established} · Reg. No. {TRUST.regNumber}<br />
            {TRUST.regAct}<br />
            DARPAN: {TRUST.darpanId}
          </div>
        </div>
      </div>
      <div className="border-t border-ivory/10 py-5 text-center text-xs text-ivory/60">
        © 2026 Sri Akilandeswari Amman Trust. All Rights Reserved.
      </div>
    </footer>
  );
}
